import React from 'react';

function CalendarEmbed() {
	return (
		<iframe
			src='https://calendar.google.com/calendar/embed?src=c_2cf4b04a11c344cd2aa17090528dc67503d54eb23121f151751b75d0f715a717%40group.calendar.google.com&ctz=America%2FLos_Angeles'
			width='800'
			height='600'
			scrolling='no'
			title='calendar'
		></iframe>
	);
}

export default CalendarEmbed;
